const points = [[642, 460], [819, 414], [1013, 436], [1240, 476], [1286, 745], [702, 989], [903, 1111], [864, 759], [431, 476], [1695, 867], [2136, 773], [2337, 996], [2464, 1152], [2526, 1360], [2349, 1528], [1985, 1516], [1554, 1147], [2004, 1164], [2136, 2035], [2344, 2026], [2442, 2222], [2385, 2354], [2164, 2337], [2052, 2133], [2442, 1961], [2653, 1973], [2768, 2085], [2536, 2437], [1803, 2492], [2102, 2473], [2263, 2684], [2239, 2950], [2009, 3117], [1757, 3096], [1619, 2691], [431, 2413], [728, 2646], [630, 2373], [927, 2160], [1087, 2497], [721, 2557], [1056, 2732], [1085, 2959], [824, 3074], [1061, 3206], [1209, 2955], [1183, 2373], [929, 2327], [946, 2061], [1221, 2162], [1202, 2416], [1429, 2437], [1484, 2186], [1346, 2045], [1396, 1884], [1568, 1733], [1745, 1903], [2016, 1971], [1954, 2136], [1664, 2200], [1506, 2133], [1604, 1944], [1623, 2351], [1599, 2636], [761, 1283], [1044, 1549], [723, 1597], [979, 1298], [912, 1662], [852, 1812], [692, 1765], [544, 1518], [706, 1398], [496, 1374], [553, 1267], [522, 1164], [390, 1116], [316, 1250], [189, 1101], [1391, 1216], [1666, 1176], [1791, 1355], [1690, 1511], [1499, 1599], [1343, 1362], [1585, 1355], [1360, 3443], [1681, 3515], [1559, 3649], [1449, 3594], [1283, 3668], [2212, 3218], [2437, 3096], [2686, 2607], [2289, 1887], [2430, 1817], [2610, 1789], [2744, 1841], [692, 1997], [450, 2205], [575, 2272], [788, 1860], [804, 2038], [464, 1688], [259, 1698], [1070, 1722], [1319, 1530], [1243, 1638], [2155, 1726], [2184, 1868], [2322, 1784], [2265, 2859], [2442, 2818], [2095, 3149], [1923, 2840], [1781, 2811], [1621, 2940], [2014, 2698], [1947, 2416], [460, 2768], [354, 2691], [134, 1887], [268, 1980], [294, 2260], [498, 2054], [1362, 2768], [1437, 3242], [1628, 3189], [1580, 3371], [1192, 2593], [910, 2591], [2248, 2179], [907, 1439], [2313, 1231], [2210, 1362], [1997, 1358], [1829, 1228], [1839, 1042], [2093, 989], [2164, 1058], [1334, 943], [1456, 759], [2777, 2234], [2576, 2265], [2550, 2157], [1154, 1961], [1104, 1844]]

function createWeights(count, size)
{
    const weights = []

    let a=5,b=3,h
    let prev = 0
    for (let i = 0; i < count; i++)
    {
        weights.push(size)

        if (i - prev >= a)
        {
            size *= 0.9

            h = b
            b = a + b
            a = h

            prev = i
        }
    }
    return weights
}

function shuffle(a) {
    let j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}


function removeClosest(circles, discardRate)
{
    const distances = []

    for (let i = 0; i < circles.length; i++)
    {
        const circle = circles[i]
        for (let j = i + 1; j < circles.length; j++)
        {
            const other = circles[j]

            const {x: x0, y: y0, r: r0 } = circle
            const {x: x1, y: y1, r: r1 } = other

            const dx = x1 - x0
            const dy = y1 - y0
            const distance = Math.sqrt(dx*dx+dy*dy)

            distances.push({
                i,
                j,
                distance
            })
        }
    }

    distances.sort((a,b) => a.distance - b.distance)

    const discard = Math.floor(distances.length * discardRate)

    const out = []

    const merged = new Set()
    for (let k = 0; k < discard; k++)
    {
        const {i, j} = distances[k]

        const circle = circles[i]
        const other = circles[j]

        out.push({
            x: (circle.x + other.x) / 2,
            y: (circle.y + other.y) / 2,
            radius: joinedRadius(circle.radius, other.radius)
        })

        merged.add(i)
        merged.add(j)

    }

    return out.concat(
        circles.filter((c,i) => !merged.has(i))
    )
}


function joinedRadius(r0,r1)
{
    return Math.sqrt((Math.PI * r0 * r0 + Math.PI * r1 * r1)/Math.PI)
}

export function createCircles(count)
{
    if (count > points.length)
    {
        throw new Error("Count must be smaller than number of points: " + count + " > " + pts.length)
    }

    shuffle(points)

    const pts = points.slice(0, count)

    let size = 1;


    const weights = createWeights(count, size)
    const radii = Array.from(pts, pt => Infinity)

    const limit = Math.round(pts.length * 0.5)

    const out = []
    for (let i = 0; i < pts.length; i++)
    {
        const [x0, y0] = pts[i]
        for (let j = 0; j < limit; j++)
        {
            if (i === j)
            {
                continue
            }

            const [x1, y1] = pts[j]

            const dx = x1 - x0
            const dy = y1 - y0

            const distance = Math.sqrt(dx * dx + dy * dy)

            const sum = weights[i] + weights[j]
            const w0 = distance * weights[i] / sum
            const w1 = distance * weights[j] / sum

            if (w0 < radii[i])
            {
                radii[i] = w0
            }
            if (w1 < radii[j])
            {
                radii[j] = w1
            }
        }

        out.push({
            x: Math.round(x0),
            y: Math.round(y0),
            radius: Math.round(radii[i] * (1 + Math.random() * 0.5) )
        })
    }
    return removeClosest(out, 0.06)
}
